import { useTranslation } from "react-i18next";
import { DefectComment, ImageList, PunchlistText } from "../..";
import { UserRole } from "imagine-users";
import { DateTimeFormat, DateTimeText } from "imagine-datetime";
import { Card } from "imagine-ui";
import { Api } from "imagine-essentials";

interface Props {
  comment: DefectComment;
  className?: string;
}

export const CommentInfo = (props: Props) => {
  const { t } = useTranslation();
  const roleText = PunchlistText.getRoleTextNoAdmin(
    props.comment.userRole || UserRole.NONE
  );

  return (
    <Card className={props.className}>
      <div className="row column--sm">
        <div className="text-bold">{roleText}</div>
        <div className="text-dark-muted ml-sm ml-none--sm mt-xs--sm">
          {DateTimeText.getDbDateTimeText(
            props.comment.dateCreated || "",
            DateTimeFormat.LONG_DATE_AND_TIME
          )}
        </div>
      </div>
      <div className="mt-sm">{props.comment.text}</div>
      {props.comment.images && (
        <ImageList
          images={props.comment.images}
          url={Api.getHost() + "/upload/comment-images/"}
          readonly
          className="mt-sm"
        />
      )}
    </Card>
  );
};
